import React from "react";
import { Box, IconButton } from "@mui/material";
import { Mic } from "@mui/icons-material";

export function RecordingStopButton({ isRecording, loading, onStop }) {
  if (!isRecording) return null;

  return (
    <Box
      sx={{
        p: { xs: "8px 16px", sm: "10px 20px", md: "12px 24px" },
        mx: "auto",
        backgroundColor: "rgba(76, 175, 80, 0.04)",
        borderTop: "1px solid rgba(76, 175, 80, 0.12)",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <IconButton
        onClick={onStop}
        disabled={loading}
        aria-label="stop recording"
        sx={{
          backgroundColor: "#4caf50",
          color: "white",
          width: { xs: "44px", sm: "46px", md: "48px" },
          height: { xs: "44px", sm: "46px", md: "48px" },
          borderRadius: "50%",
          boxShadow: "0 4px 12px rgba(76, 175, 80, 0.3)",
          border: "2px solid rgba(76, 175, 80, 0.2)",
          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
          "&:hover": {
            backgroundColor: "#45a049",
            transform: "scale(1.05)",
            boxShadow: "0 6px 20px rgba(76, 175, 80, 0.4)",
          },
        }}
        className={isRecording ? "pulsing-mic" : ""}
      >
        <Mic sx={{ fontSize: { xs: "20px", sm: "22px", md: "24px" } }} />
      </IconButton>
    </Box>
  );
}

